
// Custom theme for react-select
export const customSelectTheme = theme => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary25: 'var(--color-grey)',
      neutral0: 'var(--color-background)',
      neutral80: 'var(--color-foreground)',
    },
  });
  